import api from '@/api/resourceLibrary'

const state = {

}

const actions = {
  getResourceLibraryInfo (context, params) {
    return api.getResourceLibraryInfo(params)
  },
  uploadResourceToLibrary (context, resourceInfo) {
    return api.uploadResourceToLibrary(resourceInfo)
  },
  getVideoNavigationConfig (context, params) {
    return api.getVideoNavigationConfig(params)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
